import React from "react";
import CancellationsComponent from "../../components/Cancellations/Cancellations.component";
import IPage from "../../interfaces/page";

const CancellationsPage: React.FunctionComponent<IPage> = (props: IPage) => {
    return <CancellationsComponent></CancellationsComponent>;
};

export default CancellationsPage;
